import { Required, DataValidator, IsArray, IsString } from "@/utils/type-vaildator";
import api from "./api";

export interface GenerateGeminiImageRequest {
  agentId: string;
  fileUrls?: string[];
  text: string;
  level?: string;
  modelId: string;
  aspectRatio?: string;
  imageSize?: string;
  count?: number;
  type: number;
}

class MakeGenerateResponseRaw {
  @Required("taskId cannot be empty")
  @IsString("taskId must be a string")
  taskId: string;
}

// 生成 Gemini 图片
export const generateGeminiImage = async ({
  agentId,
  text,
  type,
  modelId,
  imageSize,
  count,
  aspectRatio,
  level,
  fileUrls,
}: GenerateGeminiImageRequest): Promise<string> => {
  const res = await api.post<MakeGenerateResponseRaw>("/sj/gemini/image_generate/create", {
    agent_id: agentId,
    fileUrls,
    text,
    level: level,
    modelId,
    aspectRatio: aspectRatio,
    imageSize,
    resolution: imageSize,
    count,
    type,
  });
  const root = res.data;
  const validated = DataValidator.validateOrThrow(root, MakeGenerateResponseRaw);
  return validated.taskId;
};
